// Stands in for mrujs.fetch, which these controllers only ever used to get
// the CSRF header attached — every caller already handles its own response.
//
// Rails doesn't verify the token on GET/HEAD, and mrujs skipped it there too
// (`if (!_isGetRequest) CSRFProtection(request)`), so match that.
export function csrfFetch(url, options = {}) {
  const method = (options.method || "GET").toUpperCase()
  if (method === "GET" || method === "HEAD") return fetch(url, options)

  const token = document.querySelector('meta[name="csrf-token"]')?.content

  return fetch(url, {
    ...options,
    headers: {...options.headers, "X-CSRF-Token": token}
  })
}

// mrujs.urlEncodeFormData dropped File entries before encoding. Passing a
// FormData straight to URLSearchParams is NOT the same — it stringifies a File
// to "[object File]" — so keep the filter.
export function urlEncodeFormData(formData) {
  return new URLSearchParams([...formData].filter(([, value]) => typeof value === "string"))
}
